const createEmoji = (emoji, x, y) => {
    const star = document.createElement('div');
    star.innerText = emoji;
    star.style.position = 'fixed';
    star.style.left = `${x}px`;
    star.style.top = `${y}px`;
    star.style.fontSize = '24px';
    star.style.pointerEvents = 'none';
    star.style.zIndex = 9999;
    star.style.transition = 'transform 1s ease-out, opacity 1s ease-out';
    
    document.body.appendChild(star);
  
    const angle = Math.random() * 2 * Math.PI;
    const radius = Math.random() * 100 + 50;
    const dx = Math.cos(angle) * radius;
    const dy = Math.sin(angle) * radius;
  
    requestAnimationFrame(() => {
      star.style.transform = `translate(${dx}px, ${dy}px) scale(1.5)`;
      star.style.opacity = '0';
    });
  
    setTimeout(() => {
      star.remove();
    }, 1000);
  };
  
  export const fireEmojiStars = (event) => {
    const emojis = ['🌟', '✨', '💫', '⭐', '🎉'];
    const rect = event.currentTarget.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
  
    for (let i = 0; i < 15; i++) {
      const emoji = emojis[Math.floor(Math.random() * emojis.length)];
      createEmoji(emoji, x, y);
    }
  };
  